import { Component, Input, SimpleChanges, OnChanges } from '@angular/core';
import { ITravelDeparture } from 'app/travel/travel.interfaces';
import { FormGroup, FormControl } from '@angular/forms';

@Component({
    selector: 'sbw-travel-departure',
    templateUrl: './travel-departure.component.html',
    styleUrls: ['./travel-departure.component.css', './travel-departure.component.scss']
})
export class TravelDepartureComponent implements OnChanges {

    @Input() content: any
    @Input() outboundRoute: ITravelDeparture
    @Input() returnRoute: ITravelDeparture
    @Input() formDepartureSelections: FormGroup
    @Input() datePickerInfoLabel: string

    ngOnChanges(changes: SimpleChanges) {
        let { returnRoute } = changes
        if (!returnRoute) return
        if (this.isMiniCruise()) this.oneWay.setValue(false)
        else if (this.isOneWayOnly()) this.oneWay.setValue(true)
    }

    isMiniCruise(): boolean {
        return !this.returnRoute.routes.some(r => r.routeCode == 'ONE_WAY')
    }

    isOneWayOnly(): boolean {
        return this.returnRoute.routes.every(r => r.routeCode == 'ONE_WAY')
    }

    get outboundRouteCode(): FormControl {
        return this.formDepartureSelections.get('outboundRouteCode') as FormControl
    }

    get outboundDepartureDate(): FormControl {
        return this.formDepartureSelections.get('outboundDepartureDate') as FormControl
    }

    get returnDepartureDate(): FormControl {
        return this.formDepartureSelections.get('returnDepartureDate') as FormControl
    }

    get oneWay(): FormControl {
        return this.formDepartureSelections.get('oneWay') as FormControl
    }

    public changeDepartureType(type: string) {
        if (this.isMiniCruise() || this.isOneWayOnly()) return
        this.oneWay.setValue(type == 'oneway')
    }

    public getOutboundDateIcon() {
        return "/_ng/booking/assets/datepicker_outbound_blue.svg"
    }

    public getReturnDateIcon() {
        return this.returnDepartureDate.disabled ? "/_ng/booking/assets/datepicker_return_grey.svg" : "/_ng/booking/assets/datepicker_return_blue.svg"
    }

    public getReturnRouteCode() {
        return this.returnRoute.routes.filter(r => r.routeCode != 'ONE_WAY').map(i => i.routeCode)[0]
    }

}


